import React, { FC, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { Container } from "@mui/material";

import Page from "../../components/Page";
import { useSelector } from "../../store";
import { useCompleteCheckoutSessionMutation } from "../../store/pomeriumApi";

const Success: FC = () => {
  const [searchParams] = useSearchParams();
  const { organizationId } = useSelector((state) => state.current);
  const [completeCheckoutSession] = useCompleteCheckoutSessionMutation();

  useEffect(() => {
    const checkoutSessionId = searchParams.get("checkoutSessionId");
    if (checkoutSessionId) {
      completeCheckoutSession({
        organizationId,
        completeCheckoutSessionRequest: {
          checkoutSessionId: checkoutSessionId,
        },
      });
    }

    const returnUrl = searchParams.get("returnUrl");
    if (returnUrl) {
      location.href = returnUrl;
    }
  }, [searchParams.get("checkoutSessionId"), searchParams.get("returnUrl")]);

  return (
    <Page title="Success">
      <Container maxWidth={false}>Checkout Completed</Container>
    </Page>
  );
};
export default Success;
